import React from "react";
import Typography from '@mui/material/Typography';

const Services = () => {
    return (
        <Typography>
            Services
        </Typography>
    );
  };

  export default Services;